function initColorSwatch() {
    const colorSwatches = document.querySelectorAll('.swatch-btn');
    const realSelect = document.querySelector('select#pa_couleurs');

    if (!realSelect) return;

    colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', function (e) {
            e.preventDefault();

            const selectedValue = this.getAttribute('data-value');

            realSelect.value = selectedValue;

            realSelect.dispatchEvent(new Event('change', { bubbles: true }));

            colorSwatches.forEach(s => s.classList.remove('is-selected'));
            this.classList.add('is-selected');
        });
    });
};